import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CanonicalService {
      private renderer: Renderer2;
        constructor(
            private rendererFactory: RendererFactory2,
            @Inject(DOCUMENT) private document: Document,
            private router: Router
        ) {
            this.renderer = rendererFactory.createRenderer(null, null);
            this.router.events.pipe(
              filter(event => event instanceof NavigationEnd)
            ).subscribe(() => {
              this.updateCanonicalURL(this.document.URL);
            });
        }
    
        updateCanonicalURL(url: string) {
            let canonical = this.document.head.querySelector(`link[rel='canonical']`);
            if (!canonical) {
                canonical = this.renderer.createElement('link');
                this.renderer.setAttribute(canonical, 'rel', 'canonical');
                this.renderer.appendChild(this.document.head, canonical);
            }
            this.renderer.setAttribute(canonical, 'href', url);
        }
}
